import { useEffect, useState } from "react";
import api from "@/utils/axios-utils";

export function useSpaceRecap<T>(url: string) {
  const [state, setState] = useState<{
    status: "loading" | "error" | "ready";
    data?: T;
  }>({ status: "loading" });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    let timer: ReturnType<typeof setTimeout>;
    setState({ status: "loading" });
    const request = (attempt: number) => {
      api
        .get<T>(url)
        .then(({ data }) => {
          if (active) setState({ status: "ready", data });
        })
        .catch(() => {
          if (!active) return;
          if (attempt < 2) timer = setTimeout(() => request(attempt + 1), 1500);
          else setState({ status: "error" });
        });
    };
    request(1);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [url, retry]);
  return { ...state, retry: () => setRetry((value) => value + 1) };
}
